import { makeStyles } from "@material-ui/core/styles";
import useNotificationSubscription from "../hooks/useNotificationSubscription";
import GeneralSubmitButton from "../../../components/1elements/Buttons/TextButtons/GeneralSubmitButton";

const SubscriptionForm = ({ sectionName }) => {
    const { formik } = useNotificationSubscription();
    const classes = useStyles();

    return (
        <form
            onSubmit={formik.handleSubmit}
            className={classes.subscriptionForm}
        >
            <input 
                className={classes.subscriptionTextBox}
                id="email"
                name="email"
                type="email"
                placeholder="Enter Your Email"
                onChange={formik.handleChange}
                value={formik.values.email}
                required
            />
            <GeneralSubmitButton
                text="Subscribe"
                className={classes.subscriptionButton}
            />
        </form>
    );
};

export default SubscriptionForm;

const useStyles = makeStyles((theme) => ({
    subscriptionForm: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    subscriptionTextBox: {
        backgroundColor: theme.palette.quaternary.main,
        color: theme.palette.primary.main,
        width: "200px",
        boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.25)",
        borderRadius: "5px",
        border: "none",
        fontFamily: "Lato",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "17px",
        padding: "10px",
        "&:focus": {
            outline: "none",
            boxShadow: `${theme.boxShadow} !important`
        },
        '&:hover': {
            boxShadow: `${theme.boxShadow} !important`
        }
    },
    subscriptionButton: {
        padding: "0 15px",
        marginLeft: "20px",
    },
}));
